import { useQuery } from "@apollo/client";

import {
  GetJourneyWithCareProfileDocument,
  GetJourneyWithCareProfileQuery,
  GetJourneyWithCareProfileQueryVariables
} from "@typing/Generated";

const useGetJourneyWithCareProfileQuery = (journeyId: string) =>
  useQuery<GetJourneyWithCareProfileQuery, GetJourneyWithCareProfileQueryVariables>(GetJourneyWithCareProfileDocument, {
    variables: {
      id: journeyId
    }
  });

export default useGetJourneyWithCareProfileQuery;
